import React, {Component, useEffect} from 'react';
import {
   View,
   Image,
   StyleSheet,
   Dimensions,
   ImageBackground,
   Text,
   TouchableOpacity,
   Platform,
   ActivityIndicator,
} from 'react-native';
import {
   downloadViewColor,
   white,
   FONT_FAMILY_REGULAR,
   downloadCourseMiddleBarColor,
   isWeb,
   isDesktop,
   BACK_ARROW_HOVER_TINT_COLOR,
   isiOS,
   isWindows,
} from '../../utils/utils';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import {useSelector} from 'react-redux';
// import {AnimatedCircularProgress} from 'react-native-circular-progress';
import Threedot from '../../components/Threedot';
import {IndeterMinateProgress} from '../../utils/indeterminateProgress';
import UISvg from '../../components/svg';
import {useState} from 'react';

const {width, height} = Dimensions.get('window');

const DownloadCourseScreen = ({progressUpdate, onExitClick}) => {
   const [isHover, setHover] = useState(false);
   const isLandscapemode = useSelector(selectScreenOrientation);
   return (
      <View
         style={[
            styles.container,
            {
               paddingTop: isiOS || isLandscapemode ? null : 16,
               ...Platform.select({
                  web: {
                     background:
                        'linear-gradient(180deg, #022053 0%, #003CA3 100%)',
                     paddingTop: 0,
                  },
               }),
            },
         ]}>
         {Platform.OS !== 'web' && (
            <UISvg
               height="100%"
               width="100%"
               x1="50%"
               y1="0%"
               x2="50%"
               y2="100%"
               offset={['0%', '100%']}
               stopColor={['#022053', '#003CA3']}
               stopOpacity={['1', '0']}
            />
         )}
         <View
            style={{
               flexDirection: 'row',
               alignItems: 'center',
               height: '10%',
               minHeight: 88,
               justifyContent: 'space-between',
               ...Platform.select({
                  web: {
                     background: isLandscapemode
                        ? 'linear-gradient(180deg, #003CA3 0%, #022053 100%)'
                        : 'transparent',
                     minHeight: 48,
                     minWidth: '100%',
                  },
               }),
            }}>
            <View style={{flexDirection: 'row', alignItems: 'center'}}>
               <TouchableOpacity
                  style={{padding: 10, marginTop: 0}}
                  onPress={onExitClick}
                  onMouseEnter={() => {
                     setHover(true);
                  }}
                  onMouseLeave={() => {
                     setHover(false);
                  }}>
                  <Image
                     source={require('../../assets/back_arrow.png')}
                     style={{
                        width: !isLandscapemode ? 24 : 18,
                        height: !isLandscapemode ? 24 : 18,
                        marginLeft: !isLandscapemode ? 7 : 10,
                        tintColor: isHover
                           ? BACK_ARROW_HOVER_TINT_COLOR
                           : white,
                     }}
                  />
               </TouchableOpacity>
               {/* <Text
                  style={{
                     fontSize: !isLandscapemode ? 16 : 24,
                     fontWeight: '600',
                     fontFamily: FONT_FAMILY_REGULAR,
                     color: 'white',
                     marginStart: 15,
                     marginTop: 0,
                  }}>
                  {'Back'}
               </Text> */}
            </View>
            <View style={{flexDirection: 'row-reverse', alignItems: 'center'}}>
               <Image
                  source={require('../../assets/my_Logo_96.png')}
                  style={{
                     width: 40,
                     height: 40,
                     marginLeft: 16,
                     marginRight: 16,
                  }}
               />
            </View>
         </View>
         <View style={[styles.upperView, {flex: isLandscapemode ? 1 : 2}]}>
            <View style={styles.messageView}>
               <View
                  style={[
                     styles.textContainer,
                     {marginTop: isLandscapemode ? -80 : 0},
                  ]}>
                  {Platform.OS === 'web' ? (
                     <View
                        style={
                           !isLandscapemode
                              ? [
                                   styles.messageTitle,
                                   isWeb && {marginTop: -60, marginBottom: 5},
                                ]
                              : styles.messageTitleLandscape
                        }>
                        <Threedot />
                     </View>
                  ) : (
                     <View
                        style={
                           !isLandscapemode
                              ? [styles.messageTitle]
                              : [
                                   styles.messageTitleLandscape,
                                   {marginBottom: 22},
                                ]
                        }>
                        {/* <Threedot /> */}
                        {isWindows ? (
                           <ActivityIndicator size={'large'} color={white} />
                        ) : (
                           <Threedot />
                        )}
                     </View>
                  )}
                  <Text
                     style={
                        !isLandscapemode
                           ? [styles.messageTitle]
                           : [
                                styles.messageTitleLandscape,
                                {marginBottom: isWindows ? 3 : 10},
                                (isWeb || isDesktop) && {
                                   marginTop: isWindows ? 10 : 24,
                                },
                             ]
                     }>
                     {'Downloading Course'}
                  </Text>
                  <Text
                     numberOfLines={3}
                     style={
                        !isLandscapemode
                           ? styles.subMessageText
                           : styles.subMessageTextLandscape
                     }>
                     {'Please wait while the course data downloads...'}
                     {/* {Platform.OS === 'web' && progressUpdate === 0 ? (
                        <Threedot />
                     ) : (
                        ' ...'
                     )} */}
                     {progressUpdate === Infinity
                        ? ''
                        : progressUpdate > 0
                        ? progressUpdate
                        : ''}
                     {progressUpdate === Infinity
                        ? ''
                        : progressUpdate > '0'
                        ? '%'
                        : ''}
                  </Text>
               </View>
            </View>
         </View>
         {/* {Platform.OS != 'android' ? (
            <View
               style={{
                  // backgroundColor: downloadCourseMiddleBarColor,
                  height: 8,
               }}
            />
         ) : (
            <></>
         )} */}
         {/* {Platform.sOS === 'android' ? <IndeterMinateProgress /> : <></>} */}
      </View>
   );
};

const styles = StyleSheet.create({
   container: {
      width: '100%',
      height: '100%',
      // backgroundColor: downloadViewColor,
   },
   upperView: {
      width: '100%',
      height: '90%',
      // backgroundColor: downloadViewColor,
      justifyContent: 'center',
      alignItems: 'center',
   },
   messageView: {
      width: '100%',
      height: '100%',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
   },
   downloadImage: {
      width: 32,
      height: 32,
   },
   downloadImageLandscape: {
      width: 40,
      height: 40,
   },
   ellipseBackground: {
      width: 48,
      height: 48,
      marginHorizontal: 16,
      justifyContent: 'center',
      alignItems: 'center',
   },
   ellipseBackgroundLandscape: {
      width: 72,
      height: 72,
      marginHorizontal: 20,
      justifyContent: 'center',
      alignItems: 'center',
   },
   messageTitle: {
      fontSize: 20,
      textAlign: 'center',
      fontWeight: '700',
      fontFamily: FONT_FAMILY_REGULAR,
      width: 205,
      height: 24,
      color: white,
   },
   messageTitleLandscape: {
      fontSize: 24,
      textAlign: 'center',
      fontFamily: FONT_FAMILY_REGULAR,
      fontWeight: '700',
      width: 368,
      color: white,
      marginTop: 5,
   },
   subMessageText: {
      color: white,
      textAlign: 'center',
      fontFamily: FONT_FAMILY_REGULAR,
      fontSize: 12,
      fontWeight: '500',
      fontStyle: 'italic',
      marginTop: 5,
   },
   subMessageTextLandscape: {
      color: white,
      textAlign: 'center',
      fontSize: 16,
      fontWeight: '500',
      fontFamily: FONT_FAMILY_REGULAR,
      marginTop: 5,
   },
   textContainer: {
      flexDirection: 'column',
      alignItems: 'center',
   },
   lowerView: {
      width: '100%',
      flex: 1,
      // backgroundColor: downloadViewColor,
      justifyContent: 'center',
   },
   image: {
      width: '100%',
      height: '100%',
      resizeMode: 'cover',
      justifyContent: 'center',
      alignItems: 'center',
   },
   logoImage: {
      width: 80,
      height: 80,
   },
   logoImageLandscape: {
      width: 240,
      height: 240,
   },
   buttonTitle: {
      color: 'gray',
      fontWeight: '700',
      textAlign: 'center',
      fontFamily: FONT_FAMILY_REGULAR,
      marginTop: 10,
      marginRight: 10,
   },
   buttonView: {
      minHeight: 32,
      borderRadius: 6,
   },
   crossImage: {
      width: 24,
      height: 24,
      marginLeft: 20,
   },
   crossImageLandscape: {
      width: 40,
      height: 40,
      marginTop: 25,
      marginRight: 25,
   },
});

export default DownloadCourseScreen;
